import vehicleImage from '../images/ecosmart.png';
import vehicleImage_8 from '../images/vehicletype-8.png';
import vehicleImage_17 from '../images/vehicletype-17.png';
import vehicleImage_18 from '../images/vehicletype-18.png';
import vehicleImage_20 from '../images/vehicletype-20.png';
import vehicleImage_21 from '../images/vehicletype-21.png';
import vehicleImage_22 from '../images/vehicletype-22.png';


export const getVehicleImage = (vehicleType) => {
    switch (vehicleType) {
      case 8:
        return vehicleImage_8;
      case 17:
        return vehicleImage_17;
      case 18:
        return vehicleImage_18;
      case 20:
        return vehicleImage_20;
      case 21:
        return vehicleImage_21;
      case 22:
        return vehicleImage_22;
      default:
        return vehicleImage;
    }
  };

export const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  return mobileRegex.test(userAgent.toLowerCase());
};

export const isIOS = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

export const isWebView = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Android WebView detection
  if (/android/i.test(userAgent)) {
    // Check for WebView indicators
    const isWebView = /wv\)|\.0\.0\.0|; wv\)/i.test(userAgent) || 
                     /version\/[\d.]+.*mobile.*safari/i.test(userAgent) === false ||
                     /chrome\/[\d.]+ mobile/i.test(userAgent) === false ||
                     // Additional checks for various WebView implementations
                     userAgent.includes('; wv)') ||
                     userAgent.includes('Version/4.0') ||
                     (userAgent.includes('Chrome') && !userAgent.includes('Version'));
    return isWebView;
  }
  
  // iOS WebView detection
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    // Check if not Safari (likely a WebView)
    return !userAgent.includes('Safari') || userAgent.includes('WebView');
  }
  
  return false;
};

export const isIOSWebView = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // iOS WebView specific detection
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    // Safari browser will have both 'Safari/' and 'Version/' in the user agent
    // WebViews typically lack one or both of these
    const hasSafari = userAgent.includes('Safari/');
    const hasVersion = userAgent.includes('Version/');
    const hasWebView = userAgent.includes('WebView');
    
    // If it explicitly mentions WebView, it's definitely a WebView
    if (hasWebView) {
      return true;
    }
    
    // Safari browser has both Safari/ and Version/
    // WebViews often lack Version/ even if they have Safari/
    if (hasSafari && hasVersion) {
      return false; // This is likely Safari
    }
    
    // If it has Safari/ but no Version/, it might be a WebView
    // But we need to be more careful here
    if (hasSafari && !hasVersion) {
      // Additional check: Safari should have 'Mobile/' followed by version and then 'Safari/'
      // WebViews might have different patterns
      const safariPattern = /Mobile\/[\d\w.]+ Safari\//;
      return !safariPattern.test(userAgent);
    }
    
    // If no Safari/ at all, it's likely a WebView
    if (!hasSafari) {
      return true;
    }
  }
  
  return false;
};

// Debug utility to help troubleshoot user agent detection
export const getUserAgentInfo = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return {
    userAgent,
    isMobile: isMobileDevice(),
    isIOS: isIOS(),
    isWebView: isWebView(),
    isIOSWebView: isIOSWebView(),
    details: {
      hasSafari: userAgent.includes('Safari/'),
      hasVersion: userAgent.includes('Version/'),
      hasWebView: userAgent.includes('WebView'),
      hasMobile: userAgent.includes('Mobile/'),
    }
  };
};

// Get mobile-optimized file accept types
export const getMobileFileAccept = (allowedTypes = ["image/jpeg", "image/png", "image/webp"]) => {
  // On mobile, we want to include HEIC/HEIF for better iOS support
  const mobileTypes = [...allowedTypes];
  
  if (isMobileDevice() && isIOS()) {
    // Add HEIC support for iOS devices
    if (!mobileTypes.includes("image/heic")) {
      mobileTypes.push("image/heic");
    }
    if (!mobileTypes.includes("image/heif")) {
      mobileTypes.push("image/heif");
    }
  }
  
  return mobileTypes;
};